// Internal components (not part of public API)

export {
  type ControlButtonType,
  ControlPanel,
  type ControlPanelProps,
} from "./ControlPanel";
export { CRTFrame, type CRTFrameProps } from "./CRTFrame";
export { PowerButton, type PowerButtonProps } from "./PowerButton";

// Hook re-export
import { ScreenBackground } from "./ScreenBackground";

export { useScreenDimensions } from "./ScreenBackground";

import { ScreenChannel } from "./ScreenChannel";
import { ScreenContent } from "./ScreenContent";
import { ScreenFooter } from "./ScreenFooter";
import { ScreenRoot } from "./ScreenRoot";

// CRTScreen namespace - all components are siblings, recomposed by Root
export const CRTScreen = {
  Root: ScreenRoot,
  Background: ScreenBackground,
  Content: ScreenContent,
  Footer: ScreenFooter,
  Channel: ScreenChannel,
} as const;

export namespace CRTScreen {
  export type RootProps = import("./ScreenRoot").ScreenRootProps;
  export type RootHandle = import("./ScreenRoot").ScreenRootHandle;
  export type RootAudioConfig = import("./ScreenRoot").RootAudioConfig;
  export type BackgroundProps =
    import("./ScreenBackground").ScreenBackgroundProps;
  export type ContentProps = import("./ScreenContent").ScreenContentProps;
  export type FooterProps = import("./ScreenFooter").ScreenFooterProps;
  export type ChannelProps = import("./ScreenChannel").ScreenChannelProps;
  export type ChannelAudioConfig = import("./ScreenChannel").ChannelAudioConfig;
}
